import { IS_CERTIFICATE_CHECK_ENABLED } from '~/const/Certificates/CertificatesConst';

type BankTransition = {
  isBankOffer: boolean;
  isExternalLink: boolean;
  isCertInstalled: boolean;
};

export function createCertificateCheckPolicy(isEnabled: boolean) {
  return {
    isAvailabilityCheckEnabled: isEnabled,
    isHeaderPopupEnabled: isEnabled,
    shouldShowBankTransitionPopup({
      isBankOffer,
      isExternalLink,
      isCertInstalled,
    }: BankTransition): boolean {
      return isEnabled && isBankOffer && isExternalLink && !isCertInstalled;
    },
  };
}

export const CERTIFICATE_CHECK_POLICY = createCertificateCheckPolicy(IS_CERTIFICATE_CHECK_ENABLED);
